/**
 * Media Share
 */
import VueRouter from 'vue-router';
import VueTidyRoutes from 'vue-tidyroutes';
import VueTimeago from 'vue-timeago';

import MediaApp from './components/media/app';
import Login from './components/media/app/Login';
import MediaView from './components/media/app/MediaView';
import ErrorHandler from './components/media/app/ErrorHandler';

// Timeago
Vue.use(VueRouter);
Vue.use(VueTimeago, {
    name: 'Timeago',
    locale: 'en',
});

Vue.component('media-app', MediaApp);
Vue.component('mediaview', MediaView);

// main share route
VueTidyRoutes.route(`/s/:id`, {
    name: 'home',
    component: MediaApp,
    props: (route) => {
        return { id: route.params.id };
    },
});

// main media view route
VueTidyRoutes.route(`/s/:id/m/:media_id`, {
    name: 'media-view',
    component: MediaView,
    props: (route) => {
        const params = { id: route.params.id, media_id: route.params.media_id };
        return params;
    },
});

// collection view
VueTidyRoutes.route(`/s/:id/c/:set_id`, {
    name: 'set-view',
    component: MediaView,
    props: (route) => {
        const params = { id: route.params.id, set_id: route.params.set_id };
        return params;
    },
});

// collection media view (match path)
VueTidyRoutes.route(`/s/:id/c/:set_id/m/:media_id`, {
    component: MediaView,
    props: (route) => {
        const params = { id: route.params.id, set_id: route.params.set_id, media_id: route.params.media_id };
        return params;
    },
});

// nested collection view
VueTidyRoutes.route(`/s/:id/p/:parent_id/c/:set_id`, {
    name: 'nested-set-view',
    component: MediaView,
    props: (route) => {
        const params = { id: route.params.id, parent_id: route.params.parent_id, set_id: route.params.set_id };
        return params;
    },
});

// nested collection media view (match path)
VueTidyRoutes.route(`/s/:id/p/:parent_id/c/:set_id/m/:media_id`, {
    component: MediaView,
    props: (route) => {
        const params = {
            id: route.params.id,
            parent_id: route.params.parent_id,
            set_id: route.params.set_id,
            media_id: route.params.media_id,
        };
        return params;
    },
});

// error page
VueTidyRoutes.route('/s/:id/error/:status', {
    name: 'error',
    component: ErrorHandler,
    props: (route) => {
        return { id: route.params.id, status: route.params.status };
    },
});

// login page
VueTidyRoutes.route('/s/:id/auth', {
    name: 'login',
    component: Login,
    props: (route) => {
        return { id: route.params.id };
    },
});

const router = new VueRouter({
    mode: 'history',
    hash: false,
    routes: VueTidyRoutes.export(),
});

window.App = new Vue({
    el: '#app',
    name: 'App',
    router,
    // errorCaptured(err, vm, info) {
    //     vm.$router.replace({name: 'home', params: {id: vm.$route.params.id}})
    //     return false;
    // },
});
